import { useCallback, useContext, useEffect, useRef } from 'react';
import {
    ChooseDeidentification,
    DeidentificationChoiceContext,
} from './DeidentificationChoiceProvider';

/**
 * Decides, through {@link DeidentificationChoiceProvider}, whether one
 * sending of patient data is de-identified. A question still open when the
 * calling component unmounts is declined.
 */
export default function useDeidentificationChoice(): ChooseDeidentification {
    const choose = useContext(DeidentificationChoiceContext);
    if (!choose) {
        throw new Error(
            'useDeidentificationChoice needs a DeidentificationChoiceProvider.'
        );
    }
    const mountedRef = useRef<AbortSignal>(AbortSignal.abort());

    useEffect(() => {
        const mounted = new AbortController();
        mountedRef.current = mounted.signal;
        return () => mounted.abort();
    }, []);

    return useCallback(() => choose(mountedRef.current), [choose]);
}
